module.exports = __webpack_public_path__ + "img/img02.54430240.png";